import { themeTextPrimary } from 'shared/utils/cssUtility';
import { SvgIconType } from './svg.interface';

const LinkIcon: SvgIconType = ({
  width = 12,
  height = 12,
  color = themeTextPrimary
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={color}
      d="M3.22903 12.7702C2.2442 11.7851 2.2442 10.1879 3.22903 9.20276L4.40144 8.03002C4.79009 7.64125 4.79009 7.01094 4.40144 6.62218C4.01278 6.23342 3.38266 6.23342 2.99401 6.62218L1.8216 7.79492C0.0594662 9.55756 0.0594656 12.4154 1.8216 14.178C3.58374 15.9407 6.44072 15.9407 8.20286 14.178L9.37526 13.0053C9.76392 12.6165 9.76392 11.9862 9.37526 11.5974C8.98661 11.2087 8.35649 11.2087 7.96783 11.5974L6.79543 12.7702C5.8106 13.7553 4.21387 13.7553 3.22903 12.7702Z"
    />
    <path
      fill={color}
      d="M12.771 6.79724C13.7558 5.81213 13.7558 4.21494 12.771 3.22982C11.7861 2.2447 10.1894 2.2447 9.20457 3.22982L8.03217 4.40256C7.64351 4.79132 7.01339 4.79132 6.62474 4.40256C6.23608 4.0138 6.23608 3.38349 6.62474 2.99472L7.79714 1.82198C9.55928 0.0593388 12.4163 0.0593396 14.1784 1.82198C15.9405 3.58463 15.9405 6.44244 14.1784 8.20508L13.006 9.37782C12.6173 9.76658 11.9872 9.76658 11.5986 9.37782C11.2099 8.98906 11.2099 8.35875 11.5986 7.96998L12.771 6.79724Z"
    />
    <path
      fill={color}
      d="M5.30591 10.7803C4.91726 10.3916 4.91726 9.76125 5.30591 9.37249L9.5282 5.14899C9.91685 4.76022 10.547 4.76022 10.9356 5.14899C11.3243 5.53775 11.3243 6.16806 10.9356 6.55682L6.71334 10.7803C6.32469 11.1691 5.69456 11.1691 5.30591 10.7803Z"
    />
  </svg>
);

export default LinkIcon;
